/**
 * CoreUI 3 の `CSelect` から、選ばれた値を取り出す。
 *
 * ## なぜ要るのか
 *
 * **`CSelect` は `v-model` で結べない。**CoreUI の form-mixins が
 * `input` と `change` を明示的に剥がしていて、素の `<select>` が出す
 * イベントが上まで届かない。
 *
 * ```js
 * // @coreui/vue/src/components/form/form-mixins.js
 * listeners () { const { input, change, ...listeners } = this.$listeners; return listeners }
 * ```
 *
 * 出るのは `update:value` だけ。`v-model` が待っているのは `input` なので、
 * **選んでも値が1文字も入らない。**しかも画面の表示は変わるので、
 * 見た目だけ選べているように見える。
 *
 * 実際に事故が起きた。役割を付ける画面で
 * 「モーダルを開いたときに先頭の役割を既定で入れる」処理があり、
 * **プルダウンで別の役割を選んでも先頭のまま送られた。**
 * 役割は権限の強い順に並ぶので、選んだつもりのない最上位権限が付いた。
 *
 * ## もう1つの罠
 *
 * `CSelect` が返すのは `option.value || option`。
 * つまり value が falsy（`null` / `''` / `0` / `false`）の選択肢では、
 * **その選択肢オブジェクトそのものが返る。**「選択してください」のような
 * 先頭の項目はたいてい value が空なので、そのまま入れると
 * `[object Object]` を送ることになる。
 *
 * ## 使い方
 *
 * ```html
 * <CSelect
 *   :options="options"
 *   :value="form.roleCode"
 *   @update:value="value => { form.roleCode = selectedValue(value) }"
 * />
 * ```
 *
 * `v-model` は使わない。CI が禁止している
 * （scripts/check-coreui-select-binding.js）。
 */

/**
 * @param {*} chosen CSelect の `update:value` が渡してきたもの
 * @returns {*} 選ばれた値。未選択なら空文字
 */
export function selectedValue (chosen) {
  const value = (chosen && typeof chosen === 'object' && 'value' in chosen)
    ? chosen.value
    : chosen
  return (value === null || value === undefined) ? '' : value
}

export default selectedValue
